import * as React from 'react';
import { useSelector } from 'react-redux';

import { getIsBrokerBannerAvailable } from '../../selectors/broker';

import { NewbuildingConsultBannerContainer } from '../NewbuildingConsultBanner';
import { BrokerBannerContainer } from './BrokerBannerContainer';

export function BannerContainer() {
  const isBrokerBannerAvailable = useSelector(getIsBrokerBannerAvailable);

  if (isBrokerBannerAvailable) {
    return <BrokerBannerContainer />;
  }

  return <NewbuildingConsultBannerContainer />;
}
